import React from 'react';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <span className="hero-badge">🚀 Your One-Stop Business Partner</span>
          <h1>
            We Build, Design &{' '}
            <span className="gradient-text">Manage Everything</span> Your
            Business Needs
          </h1>
          <p>
            From event management to software development, corporate gifts to
            government supplies — we deliver excellence across 9+ specialized
            services tailored for your success.
          </p>
          <div className="hero-buttons">
            <a href="#services" className="btn-primary">
              Explore Services →
            </a>
            <a href="#contact" className="btn-secondary">
              📞 Free Consultation
            </a>
          </div>
        </div>
      </div>

      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
    </section>
  );
};

export default Hero;